export var ISearchMakerProductsRequest;
(function (ISearchMakerProductsRequest) {
    let ISortingHint;
    (function (ISortingHint) {
        /**
         * Return an instance of ISortingHint with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ISortingHint.build = (partial) => (Object.assign({ ordered_categories: [], filter_keys: [], ordered_product_tokens: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ISortingHint = ISearchMakerProductsRequest.ISortingHint || (ISearchMakerProductsRequest.ISortingHint = {}));
    let IRankingBoost;
    (function (IRankingBoost) {
        /**
         * Return an instance of IRankingBoost with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IRankingBoost.build = (partial) => (Object.assign({ referrer_filters: [], referrer_products: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IRankingBoost = ISearchMakerProductsRequest.IRankingBoost || (ISearchMakerProductsRequest.IRankingBoost = {}));
    /**
     * The tags are out of order. All tag numbers must be unique. When adding fields, also update the field below and the tag number.
     * See https:www.notion.so/faire/Protocol-Buffers-Protos-ba527d2f70c34ab983b8d0417c6a56ac#6a792ceb9d37498795a117e712b9e7e7 for details.
     * The last tag added was `returnRetrievalAndRankingDebugInfo`. The next tag number is 39.
     */
    let SortBy;
    (function (SortBy) {
        /**
         * Last modified first.
         */
        SortBy["LAST_MODIFIED"] = "LAST_MODIFIED";
        /**
         * Sort alphabetically.
         */
        SortBy["A_TO_Z"] = "A_TO_Z";
        SortBy["Z_TO_A"] = "Z_TO_A";
        SortBy["FEATURED"] = "FEATURED";
        /**
         * Active products first (with FEATURED as tie-breaker).
         */
        SortBy["ACTIVE_FIRST"] = "ACTIVE_FIRST";
        /**
         * Discontinued + Backordered products first (with FEATURED as tie-breaker).
         */
        SortBy["INACTIVE_FIRST"] = "INACTIVE_FIRST";
        /**
         * Sort by Wholesale price.
         */
        SortBy["WHOLESALE_PRICE_DESC"] = "WHOLESALE_PRICE_DESC";
        SortBy["WHOLESALE_PRICE_ASC"] = "WHOLESALE_PRICE_ASC";
        SortBy["NEWEST"] = "NEWEST";
        /**
         * Sort by the category order specified in SortingHint.
         * Products in unspecified categories will be put to the end of the list.
         */
        SortBy["CATEGORIES"] = "CATEGORIES";
        /**
         * Boost the products that match the Elastic Search query in SortingHint.
         */
        SortBy["BOOST_PRODUCTS_QUERY"] = "BOOST_PRODUCTS_QUERY";
        /**
         * Boost new products (usually when brand is known)
         */
        SortBy["BOOST_NEW_PRODUCTS_QUERY"] = "BOOST_NEW_PRODUCTS_QUERY";
        /**
         * Sort by products that match the most filter keys first. Ties are broken by FEATURED ranking.
         * Intended to boost maker products ranking based of filters used in category navigation.
         */
        SortBy["FILTER_KEYS"] = "FILTER_KEYS";
        /**
         * Sort by Retail price.
         */
        SortBy["RETAIL_PRICE_DESC"] = "RETAIL_PRICE_DESC";
        SortBy["RETAIL_PRICE_ASC"] = "RETAIL_PRICE_ASC";
        /**
         * Sort by most ordered products.
         */
        SortBy["MOST_ORDERED_DESC"] = "MOST_ORDERED_DESC";
        /**
         * Sort by most recently ordered products.
         */
        SortBy["MOST_RECENT_ORDERED_DESC"] = "MOST_RECENT_ORDERED_DESC";
        /**
         * Sort by the brand's best selling products.
         * @deprecated
         */
        SortBy["BESTSELLERS"] = "BESTSELLERS";
    })(SortBy = ISearchMakerProductsRequest.SortBy || (ISearchMakerProductsRequest.SortBy = {}));
    /**
     * Expected for use by web - we can use requestInformationProvider for Mobile App.
     */
    let ClientSize;
    (function (ClientSize) {
        ClientSize["CLIENT_SIZE_UNKNOWN"] = "CLIENT_SIZE_UNKNOWN";
        ClientSize["DESKTOP"] = "DESKTOP";
        ClientSize["MOBILE"] = "MOBILE";
    })(ClientSize = ISearchMakerProductsRequest.ClientSize || (ISearchMakerProductsRequest.ClientSize = {}));
    /**
     * Return an instance of ISearchMakerProductsRequest with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ISearchMakerProductsRequest.build = (partial) => (Object.assign({ filter_keys: [], range_filters: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ISearchMakerProductsRequest || (ISearchMakerProductsRequest = {}));
